import React from "react";
import Card from "../../components/card/Card";
import NsDataTable from "../../components/tabelle/NsDataTable";
import {getStrRgba} from "../../utility/common";
import NsButtonActionsGroup from "../../components/buttons/NsButtonActionsGroup";
import NsButtonAction from "../../components/buttons/NsButtonAction";

export default function ConfStatiKpiView({
                                             stati_kpi,
                                             translate,
                                             onRowDbClick,
                                         }) {

    return (
        <Card
            icon={'fas fa-flags'}
            title={'Stati_kpi'}
        >
            <NsDataTable
                data={stati_kpi}
                columns={[
                    {
                        name: translate('Codice'),
                        selector: row => row.codice,
                        sortable: true,
                    },
                    {
                        name: translate('Descrizione'),
                        selector: row => row.descrizione,
                        sortable: true,
                    },
                    {
                        name: translate('Colore'),
                        selector: row => <div className={"ns-area-colore"}
                                              style={{backgroundColor: getStrRgba(row.colore)}}/>,
                        sortable: false
                    },
                    {
                        name: '',
                        selector: row => <NsButtonActionsGroup>
                            <li>
                                <NsButtonAction
                                    href={`/upd-stato-kpi/${row.id_stato_kpi}`}
                                    label={"Modifica"}
                                    icona={"fas fa-pen"}
                                />
                            </li>
                        </NsButtonActionsGroup>,
                        sortable: false,
                        right: true,
                    }
                ]}
                onRowDbClick={onRowDbClick}
            />
        </Card>
    );
}
